import React, { useEffect, useState } from "react";
import { Alert, Box, Container, Typography, useMediaQuery, useTheme } from "@mui/material";
import SimpleBox from "../../components/layout/container/SimpleBox";
import { useSelector } from "react-redux";
import { apiPublicGames } from "../../api/public";
import { groupGames } from "../../helpers/format";
import PreviousNextButton from "../../components/input/button/PreviousNextButton";
import DayGame from "../../components/dataitem/DayGame";
import PageContent from "../../components/layout/container/PageContent";
import EchelonSelect from "../../components/input/select/EchelonSelect";
import ShadowBox from "../../components/layout/container/ShadowBox";
import SeasonSelect from "../../components/input/select/SeasonSelect";

const Games = () => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [season, setSeason] = useState(null);
    const [rawGames, setRawGames] = useState([]);
    const [games, setGames] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(-1);
    const [selectedEchelon, setSelectedEchelon] = useState("__ALL__");

    useEffect(() => {
        if (Boolean(season)) {
            apiPublicGames({ seasonId: season.id }, (data, successFlag) => {
                if (successFlag) {
                    const { groupedGames, mainGroupIndex } = groupGames(data.games);
                    setRawGames(data.games);
                    setGames(groupedGames);
                    setCurrentIndex(mainGroupIndex);
                }
            });
        }
    }, [season]);

    const echelonOptions = Boolean(season) ? season.echelons.map(echelon => ({ id: echelon.id, label: echelon.name })) : [];
    echelonOptions.unshift({ id: "__ALL__", label: "Todos" });

    const actionPrev = selectedEchelon === "__ALL__" && currentIndex > 0 ? () => setCurrentIndex(currentIndex - 1) : null;
    const actionNext = selectedEchelon === "__ALL__" && currentIndex < games.length - 1 ? () => setCurrentIndex(currentIndex + 1) : null;

    const showGames = selectedEchelon === "__ALL__" ? games : (
        groupGames(
            rawGames.filter(game => game.echelon?.id === selectedEchelon)
        ).groupedGames
    );

    const NoGamesAlert = () => {
        return (
            <ShadowBox backgroundColor="maize" width="100%" padding={14}>
                <Typography textAlign="center" fontSize="1.4rem">Não existem jogos para a seleção escolhida</Typography>
            </ShadowBox>
        )
    }

    return (
        <PageContent backgroundColor="whiteSmoke.dark" title="Jogos">
            <Container maxWidth="md">
                <ShadowBox mt={6} padding={3}>
                    <SimpleBox
                        flexDirection={isMobile ? "column" : "row"}
                        alignItems={isMobile ? "stretch" : "center"}
                        justifyContent="flex-start"
                        flexWrap="wrap"
                        gap={4}
                    >
                        <Box sx={{ minWidth: 160, width: isMobile ? "100%" : 180 }}>
                            <SeasonSelect
                                flagParameter="hasGames"
                                onSeasonChange={setSeason} />
                        </Box>
                        <EchelonSelect
                            echelonOptions={echelonOptions}
                            selected={selectedEchelon}
                            onChange={(newValue) => setSelectedEchelon(newValue)} />
                    </SimpleBox>
                </ShadowBox>
                <SimpleBox mt={6}>
                    <PreviousNextButton action={actionPrev} type="previous" />
                    <PreviousNextButton action={actionNext} type="next" />
                </SimpleBox>
                <SimpleBox flexDirection="column" justifyContent="center" gap={10} mt={6}>
                    {
                        selectedEchelon === "__ALL__" && currentIndex - 1 >= 0 ? (
                            showGames[currentIndex - 1].games.map((gamesOfDay, dayIdx) => {
                                return <DayGame key={dayIdx} gamesOfDay={gamesOfDay} />
                            })
                        ) : null
                    }
                    {
                        selectedEchelon === "__ALL__" ? (
                            currentIndex >= 0 ? (
                                showGames[currentIndex].games.map((gamesOfDay, dayIdx) => {
                                    return <DayGame key={dayIdx} gamesOfDay={gamesOfDay} />
                                })
                            ) : (
                                <NoGamesAlert />
                            )
                        ) : null
                    }
                    {
                        selectedEchelon !== "__ALL__" ? (
                            Boolean(showGames) && showGames.length > 0 ? (
                                Object.keys(showGames).map(idx => {
                                    return showGames[idx].games.map((gamesOfDay, dayIdx) => {
                                        return <DayGame key={dayIdx} gamesOfDay={gamesOfDay} />
                                    })
                                })
                            ) : (
                                <NoGamesAlert />
                            )
                        ) : null
                    }
                </SimpleBox>
            </Container>
        </PageContent>
    )
}

export default Games;
